import { bbox, circle } from "@turf/turf";

import { MapBounds } from "~/modules/map/components/MapButtonFitBounds/types";

const PLANNER_MAP_VISIT_SCREEN_BOUNDS_KM = 15;

export function calculateVisitDetailScreenBounds(location: GeoJSON.Point | undefined): MapBounds | null {
    if (!location) {
        return null;
    }

    return { bbox: bbox(circle(location, PLANNER_MAP_VISIT_SCREEN_BOUNDS_KM)), kind: "visit" };
}
